import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import "./Overlay.css";

export default function Overlay({ onComplete }) {
  const [phase, setPhase] = useState("video");

  // --------------------------------------------------
  // GIF -> DONE (fixed 5000ms duration)
  // --------------------------------------------------
  useEffect(() => {
    if (phase !== "video") return;

    const timer = setTimeout(() => {
      handleVideoFinished();
    }, 2500);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phase]);

  const handleVideoFinished = () => {
    setPhase("done");

    if (onComplete) {
      onComplete();
    }
  };

  if (phase === "done") {
    return null;
  }

  return (
    <AnimatePresence>
      {/* =====================================================
          GANDHI GIF - shown for 5000ms
      ====================================================== */}
      {phase === "video" && (
        <motion.div
          key="video"
          className="overlay-container phase-video"
          initial={{
            opacity: 0,
            scale: 1.03,
          }}
          animate={{
            opacity: 1,
            scale: 1,
          }}
          exit={{
            opacity: 0,
            scale: 1.02,
            transition: {
              duration: 1.2,
              ease: "easeInOut",
            },
          }}
          transition={{
            duration: 1.5,
            ease: [0.22, 1, 0.36, 1],
          }}
        >
          <motion.img
            src={require("../../assests/gandhi_gif.gif")}
            alt=""
            className="fullscreen-video"
            initial={{
              opacity: 0,
              scale: 1.06,
            }}
            animate={{
              opacity: 1,
              scale: 1,
            }}
            transition={{
              duration: 2.2,
              ease: "easeOut",
            }}
          />

          {/* Soft cinematic overlay */}
          <motion.div
            className="video-overlay"
            initial={{ opacity: 0.7 }}
            animate={{ opacity: 0.15 }}
            transition={{
              duration: 2.5,
              ease: "easeOut",
            }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}